import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const DematAccount = ({ color = '#F2F7FF', ...props }: { color?: string }) => (
  <Svg width={48} height={48} viewBox="0 0 48 48" fill="none" {...props}>
    <G clipPath="url(#clip0_1051_8305)">
      <Rect width={48} height={48} rx={8} fill="#EBF3FF" />
      <Path
        d="M18.8845 32.2295V41.7218H18.8733C17.9841 41.3903 16.7573 40.9372 15.418 40.5615C15.0466 40.44 14.6527 40.3405 14.27 40.2521C13.301 40.0075 12.3156 39.8303 11.3212 39.7217V32.2295C11.3203 32.1227 11.3623 32.0199 11.4382 31.9434C11.5141 31.8668 11.6176 31.8227 11.7264 31.8206H18.4793C18.5881 31.8227 18.6917 31.8668 18.7675 31.9434C18.8434 32.0199 18.8854 32.1227 18.8845 32.2295Z"
        fill="url(#paint0_radial_1051_8305)"
      />
      <Path
        d="M29.6561 24.6191V43.5815C29.4536 43.5815 29.2397 43.5815 29.0146 43.5925L27.9454 43.6367C26.561 43.6809 25.1204 43.7362 23.6797 43.6809C23.072 43.6478 22.5543 43.6146 22.0815 43.5483V24.6191C22.0815 24.5639 22.0926 24.5093 22.114 24.4583C22.1355 24.4074 22.167 24.3611 22.2067 24.3221C22.2465 24.2831 22.2936 24.2522 22.3455 24.2311C22.3974 24.21 22.4531 24.1991 22.5092 24.1992H29.2285C29.2846 24.1991 29.3403 24.21 29.3922 24.2311C29.4441 24.2522 29.4912 24.2831 29.5309 24.3221C29.5707 24.3611 29.6022 24.4074 29.6236 24.4583C29.6451 24.5093 29.6562 24.5639 29.6561 24.6191Z"
        fill="url(#paint1_radial_1051_8305)"
      />
      <Path
        d="M40.4274 14.3201V41.5924C39.8534 41.9902 39.2569 42.4322 38.6378 42.9184C37.6362 43.703 36.6119 44.5428 35.6103 45.4268C35.4722 45.2108 35.3098 45.0106 35.1263 44.8301C34.6805 44.4302 34.1501 44.1321 33.5731 43.9571C33.3368 43.8798 33.1004 43.8245 32.8528 43.7693V14.3201C32.8528 14.265 32.8638 14.2104 32.8853 14.1594C32.9067 14.1085 32.9382 14.0622 32.978 14.0232C33.0177 13.9842 33.0648 13.9532 33.1167 13.9321C33.1686 13.911 33.2242 13.9002 33.2804 13.9002H40.0109C40.1226 13.9025 40.2289 13.9478 40.3068 14.0263C40.3847 14.1049 40.4281 14.2104 40.4274 14.3201Z"
        fill="url(#paint2_radial_1051_8305)"
      />
      <Path
        d="M4.56917 24.5906L13.0078 17.0754C13.051 17.037 13.1016 17.0076 13.1566 16.9889C13.2116 16.9702 13.2699 16.9626 13.328 16.9666C13.3861 16.9707 13.4427 16.9862 13.4945 17.0123C13.5464 17.0384 13.5922 17.0745 13.6295 17.1185L15.8366 19.7267L23.7146 11.9189L21.6379 10.3992C21.6101 10.3789 21.5892 10.3508 21.5779 10.3186C21.5666 10.2864 21.5654 10.2516 21.5746 10.2188C21.5837 10.1859 21.6027 10.1565 21.6291 10.1344C21.6555 10.1124 21.6881 10.0986 21.7226 10.095L29.2338 9.30309C29.2745 9.2988 29.3156 9.30405 29.3538 9.3184C29.3921 9.33276 29.4263 9.35581 29.4537 9.38567C29.4811 9.41553 29.5009 9.45135 29.5114 9.49018C29.522 9.52901 29.523 9.56974 29.5145 9.60904L27.9194 16.9123C27.9122 16.9454 27.8951 16.9755 27.8703 16.9989C27.8456 17.0223 27.8142 17.0379 27.7804 17.0437C27.7465 17.0495 27.7116 17.0453 27.6802 17.0315C27.6488 17.0177 27.6224 16.995 27.6042 16.9663L26.1482 14.6694L16.3847 25.104C16.343 25.1486 16.2921 25.1838 16.2353 25.2074C16.1786 25.2311 16.1174 25.2425 16.0558 25.2409C15.9942 25.2393 15.9337 25.2248 15.8783 25.1983C15.8229 25.1719 15.7739 25.1341 15.7346 25.0875L13.1892 22.0661L7.00575 27.8553C6.96055 27.8976 6.90652 27.9298 6.84741 27.9496C6.78829 27.9694 6.7255 27.9764 6.66338 27.97C6.60125 27.9637 6.54127 27.9442 6.48758 27.9128C6.43389 27.8815 6.38778 27.839 6.35243 27.7885L4.50335 25.144C4.4443 25.0595 4.41842 24.9569 4.43052 24.8551C4.44263 24.7534 4.49189 24.6594 4.56917 24.5906Z"
        fill="url(#paint3_radial_1051_8305)"
      />
      <Path
        d="M42.5245 40.9456H42.5238L32.1419 49.122C31.2886 49.794 30.1939 50.1 29.1075 49.9698L15.115 48.2979L11.3867 49.652C9.38388 47.6297 10.2069 41.5179 10.2069 41.5179L11.0948 40.8843C11.0178 39.7194 11.5773 38.5628 12.6158 37.9009C12.7304 37.8273 12.8504 37.7605 12.9768 37.6999L18.9769 34.8229L22.0627 33.3432C22.2308 33.2627 22.4022 33.1994 22.5765 33.1531C23.8663 32.8061 25.2665 33.363 25.9267 34.5571C26.6758 35.9128 26.2036 37.6072 24.8562 38.4L19.8683 41.3349L28.262 42.7704C29.2721 42.9428 30.3113 42.7342 31.1722 42.1856L39.5201 36.8651C40.6398 36.1508 42.1296 36.3989 42.9481 37.4356C43.1598 37.7042 43.3084 38.002 43.3951 38.3114C43.6575 39.2518 43.3472 40.2974 42.5245 40.9456Z"
        fill="url(#paint4_radial_1051_8305)"
      />
      <Rect
        width={5.85414}
        height={11.0687}
        rx={2.92707}
        transform="matrix(0.956097 -0.293052 0.303017 0.952985 3.7406 41.6429)"
        fill="#3666B5"
      />
    </G>
    <Defs>
      <RadialGradient
        id="paint0_radial_1051_8305"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.2503 33.9731) rotate(117.194) scale(7.81479 4.14423)"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <RadialGradient
        id="paint1_radial_1051_8305"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(27.018 28.4395) rotate(104.639) scale(14.1526 4.51469)"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <RadialGradient
        id="paint2_radial_1051_8305"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(37.7892 20.754) rotate(99.1797) scale(22.42 4.6064)"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <RadialGradient
        id="paint3_radial_1051_8305"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.4944 12.9439) rotate(149.47) scale(10.409 8.45423)"
      >
        <Stop stopColor="#FFE0B9" />
        <Stop offset={1} stopColor="#DCAD70" />
      </RadialGradient>
      <RadialGradient
        id="paint4_radial_1051_8305"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(29.4 35.04) rotate(144.121) scale(25.435 27.3161)"
      >
        <Stop stopColor="#FFEED8" />
        <Stop offset={1} stopColor="#D59A4F" />
      </RadialGradient>
      <ClipPath id="clip0_1051_8305">
        <Rect width={48} height={48} rx={8} fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default DematAccount
